export default __webpack_public_path__ + "static/media/doris.f9004fb9.png";